var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-nav-bar',{staticClass:"navBar",attrs:{"title":"莞工通讯录","z-index":"99"}}),_c('div',{staticClass:"login_but"},[_c('div',{staticClass:"CommonColor pb-3"},[_vm._v("欢迎使用莞工通讯录")]),_c('div',{staticClass:"px-3"},[_c('van-button',{attrs:{"type":"primary","size":"large"},on:{"click":_vm.login}},[_vm._v("登 录")])],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }